import {
  Box,
  Card,
  MenuItem,
  Select,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  useTheme,
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import CakeIcon from '@mui/icons-material/Cake'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import ChildCareIcon from '@mui/icons-material/ChildCare'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import Avatar from '@mui/material/Avatar'
import { makeGetRequest } from 'utils/api'
import moment from 'moment'
import { convertToMuiDate } from 'utils/helpers'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// import 'moment/locale/fr'

function MonPortrait({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const [user, setUser] = useState({})
  const [mStatus, setMStatus] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)
  const [editData, setEditData] = useState({
    nom: '',
    prenom: '',
    vile: '',
    marital_status: 0,
    nombre_enfants: 0
  })

  const handleChange = (event) => {
    setMStatus(event.target.value)
    let payload = {
      ...user,
      date_de_naissance: convertToMuiDate(user.date_de_naissance),
      marital_status: event.target.value,
    }
    delete payload.img_url
    delete payload.age
    makePostRequest('/api/user/update-profile/', payload, {}, true)
  }

  useEffect(() => {
    fetchUser()
  }, [])
  const fetchUser = async () => {
    const response = await makeGetRequest('/api/user/user/', {}, true)

    if (response.status === 200) {
      let age = calculateAge(convertToMuiDate(response.data.date_de_naissance))
      let user_data = { ...response.data, age: age }
      setMStatus(response.data.marital_status)
      setUser(user_data)
      setEditData({
        nom: response.data.nom || '',
        prenom: response.data.prenom || '',
        vile: response.data.vile || '',
        marital_status: response.data.marital_status || 0,
        nombre_enfants: response.data.nombre_enfants || 0
      })
    }
  }

  const handleOpenModal = (e) => {
    e.stopPropagation() // Prevent card drag
    setEditData({
      nom: user.nom || '',
      prenom: user.prenom || '',
      vile: user.vile || '',
      marital_status: user.marital_status || 0,
      nombre_enfants: user.nombre_enfants || 0
    })
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const handleSaveModal = async () => {
    try {
      let payload = {
        ...user,
        nom: editData.nom,
        prenom: editData.prenom,
        vile: editData.vile,
        date_de_naissance: convertToMuiDate(user.date_de_naissance),
        marital_status: editData.marital_status,
        nombre_enfants: parseInt(editData.nombre_enfants) || 0,
      }
      delete payload.img_url
      delete payload.age

      const response = await makePostRequest('/api/user/update-profile/', payload, {}, true)
      
      if (response.status === 200) {
        setMStatus(editData.marital_status)
        setUser({
          ...user,
          nom: editData.nom,
          prenom: editData.prenom,
          vile: editData.vile,
          marital_status: editData.marital_status,
          nombre_enfants: editData.nombre_enfants
        })
        setModalOpen(false)
        if (updateReports) {
          updateReports()
        }
      }
    } catch (error) {
      console.error('Error saving profile:', error)
      alert(t('monPatrimoine.saveError')) // LAP-733 (GE022)
    }
  }
  function calculateAge(birthDate) {
    const today = new Date()
    const birthDateObj = new Date(birthDate)

    let age = today.getFullYear() - birthDateObj.getFullYear()
    const monthDifference = today.getMonth() - birthDateObj.getMonth()
    const dayDifference = today.getDate() - birthDateObj.getDate()

    // If the birth month is greater than the current month or it's the current month but birth day hasn't occurred yet
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--
    }

    return age
  }
  return (
    <>
      <Card className="dashboard_card__root1" sx={{ position: 'relative', overflow: 'hidden' }}>
        {/* Halo décoratif */}
        <Box
          sx={{
            position: 'absolute',
            top: -70,
            right: -50,
            width: 170,
            height: 170,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(124,177,223,0.28), transparent 70%)',
            pointerEvents: 'none',
          }}
        />

        <Box
          className="dashboard_card__header1"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.monPortraitTitle')}
          </WTypography>
          <IconButton
            onClick={handleOpenModal}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            size="small"
            className="no-drag"
            sx={{
              color: '#cfe0f2',
              bgcolor: 'rgba(255,255,255,0.06)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.16)' },
            }}
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Identité */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            mt: 1,
          }}
        >
          <Box
            sx={{
              p: '3px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #7ab1df 0%, #1c86e9 100%)',
              display: 'inline-flex',
              boxShadow: '0 8px 22px rgba(28,134,233,0.35)',
            }}
          >
            <Avatar
              sx={{ height: 92, width: 92, border: '3px solid #001b42' }}
              alt={user.prenom || 'Avatar'}
              src={user.img_url || 'https://cdn-icons-png.flaticon.com/512/147/147140.png'}
            />
          </Box>
          <WTypography component={'div'} variant="h6" sx={{ fontWeight: 800, mt: 1.5 }}>
            {user.prenom} {user.nom}
          </WTypography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: 0.75,
              mt: 1,
            }}
          >
            {user.age ? (
              <MetaChip
                icon={<CakeIcon />}
                label={`${user.age} ${t('monPatrimoine.yearsSuffix')}`}
              />
            ) : null}
            {user.vile ? <MetaChip icon={<LocationOnIcon />} label={user.vile} /> : null}
          </Box>
        </Box>

        {/* Informations */}
        <Box sx={{ mt: 2.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <InfoTile icon={<Diversity3Icon />} label={t('monPatrimoine.familyStatus')}>
            <Select
              value={mStatus}
              onChange={handleChange}
              className="no-drag"
              size="small"
              MenuProps={{ PaperProps: { sx: { bgcolor: '#10204a', color: '#fff' } } }}
              sx={{
                color: '#fff',
                fontSize: 15,
                fontWeight: 700,
                ml: -0.5,
                '.MuiSelect-select': { padding: '2px 26px 2px 4px !important' },
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '&:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
                '.MuiSvgIcon-root': { color: '#7ab1df' },
              }}
            >
              <MenuItem value={0}>{t('monPatrimoine.single')}</MenuItem>
              <MenuItem value={'Concubin'}>{t('monPatrimoine.concubin')}</MenuItem>
              <MenuItem value={'Pacsée'}>{t('monPatrimoine.pacs')}</MenuItem>
              <MenuItem value={'mariée'}>{t('monPatrimoine.married')}</MenuItem>
              <MenuItem value={'veuve'}>{t('monPatrimoine.widowed')}</MenuItem>
              <MenuItem value={'divorcée'}>{t('monPatrimoine.divorced')}</MenuItem>
            </Select>
          </InfoTile>
          <InfoTile icon={<ChildCareIcon />} label={t('monPatrimoine.children')}>
            {user.nombre_enfants || 0}
          </InfoTile>
        </Box>
      </Card>

      {/* Settings Modal */}
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {t('monPatrimoine.editPortrait')}
        </DialogTitle>
        <DialogContent>
          <Box mt={2}>
            {/* Editable: First Name */}
            <TextField
              label={t('monPatrimoine.firstName')}
              value={editData.prenom}
              onChange={(e) => setEditData({...editData, prenom: e.target.value})}
              fullWidth
              margin="normal"
            />

            {/* Editable: Last Name */}
            <TextField
              label={t('monPatrimoine.lastName')}
              value={editData.nom}
              onChange={(e) => setEditData({...editData, nom: e.target.value})}
              fullWidth
              margin="normal"
            />

            {/* Read-only: Age */}
            <TextField
              label={t('monPatrimoine.age')}
              value={`${user.age || 0} ${t('monPatrimoine.yearsSuffix')}`}
              fullWidth
              margin="normal"
              InputProps={{ readOnly: true }}
              disabled
            />

            {/* Editable: Family Status */}
            <FormControl fullWidth margin="normal">
              <InputLabel>{t('monPatrimoine.familyStatusLabel')}</InputLabel>
              <Select
                value={editData.marital_status}
                label={t('monPatrimoine.familyStatusLabel')}
                onChange={(e) => setEditData({...editData, marital_status: e.target.value})}
              >
                <MenuItem value={0}>{t('monPatrimoine.single')}</MenuItem>
                <MenuItem value={'Concubin'}>{t('monPatrimoine.concubin')}</MenuItem>
                <MenuItem value={'Pacsée'}>{t('monPatrimoine.pacs')}</MenuItem>
                <MenuItem value={'mariée'}>{t('monPatrimoine.married')}</MenuItem>
                <MenuItem value={'veuve'}>{t('monPatrimoine.widowed')}</MenuItem>
                <MenuItem value={'divorcée'}>{t('monPatrimoine.divorced')}</MenuItem>
              </Select>
            </FormControl>

            {/* Editable: Number of children */}
            <TextField
              label={t('monPatrimoine.numberOfChildren')}
              type="number"
              value={editData.nombre_enfants}
              onChange={(e) => setEditData({...editData, nombre_enfants: e.target.value})}
              fullWidth
              margin="normal"
              inputProps={{ min: 0 }}
            />

            {/* Editable: City */}
            <TextField
              label={t('monPatrimoine.cityOfResidenceLabel')}
              value={editData.vile}
              onChange={(e) => setEditData({...editData, vile: e.target.value})}
              fullWidth
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            {t('monPatrimoine.cancel')}
          </Button>
          <Button onClick={handleSaveModal} variant="contained" color="primary">
            {t('monPatrimoine.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MonPortrait

// Petite pastille méta affichée sous le nom (âge, ville…).
function MetaChip({ icon, label }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.4,
        borderRadius: 999,
        bgcolor: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.1)',
        '& svg': { fontSize: 14, color: '#7ab1df' },
      }}
    >
      {icon}
      <Typography sx={{ color: '#e8f0f9', fontSize: 12, fontWeight: 700 }}>
        {label}
      </Typography>
    </Box>
  )
}

// Ligne d'information : tuile icône + libellé + valeur (ou champ éditable).
function InfoTile({ icon, label, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        bgcolor: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: 2,
        px: 1.25,
        py: 1,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: 38,
          height: 38,
          borderRadius: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(124,177,223,0.14)',
          color: '#7ab1df',
          '& svg': { fontSize: 20 },
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: 11,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          {label}
        </Typography>
        <Box sx={{ color: '#fff', fontSize: 15, fontWeight: 700, mt: 0.25 }}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}
